import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { NgSelectModule } from '@shared/components/ng-select/ng-select.module';
import { WCAGLabelDirective } from '@shared/directives/wcag-label.directive';
import { Subject } from 'rxjs';
import { debounceTime ,  distinctUntilChanged ,  filter ,  startWith ,  switchMap ,  takeUntil } from 'rxjs/operators';

@Component({
  selector: 'formly-field-typeahead',
  template: `
    <ng-select [items]="options$ | async"
      wcag-label
      [id]="elementId"
      [placeholder]="props.placeholder"
      [inputAttrs]="{'aria-label': props.placeholder}"
      [typeahead]="search$"
      [formControl]="formControl">
    </ng-select>
  `,
  imports: [NgSelectModule, FormsModule, ReactiveFormsModule, CommonModule, WCAGLabelDirective],
})
export class FormlyFieldTypeaheadComponent extends FieldType implements OnInit, OnDestroy {
  onDestroy$ = new Subject<void>();
  search$ = new EventEmitter();
  options$;

  ngOnInit() {
    this.options$ = this.search$.pipe(
      takeUntil(this.onDestroy$),
      startWith(''),
      filter(v => v !== null),
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(this.props.search$),
    );

    this.options$.subscribe();
  }

  get elementId(): string {
    if (this.field.id && this.field.id.includes('formly_')) {
      let prefix = this.form['id'];

      // check if in repeat section
      if (!prefix && this.field.parent.parent && this.field.parent.parent.parent && this.field.parent.parent.parent.type === 'repeat') {
        const cnt = this.field.parent.parent.key;
        prefix = `${this.field.parent.parent.parent['id']}_${cnt}`;
      }

      return `${prefix ? prefix + '_' : ''}${(this.key as string).replace('.', '_')}`;
    } else {
      return this.field.id;
    }
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }
}
